<template>
  <div>
    <p>{{ text }}</p>
    <div>
      <input
        placeholder="введите код"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      >
      <button @click="$emit('click')" :disabled>
        <slot></slot>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    emits: ['update:modelValue', 'click'],
    props: {
      text: String,
      modelValue: String,
      btnTitle: Object,
      disabled: Boolean
    }
  }
</script>

<style lang="scss" scoped >
</style>